/**
 * <s-ingredient-filter> filters the ingredient library on pages/islam-science-nature.
 * Children:
 *   input[data-search]            — free-text search over each card's data-search text.
 *   input[type=radio][data-cat]   — category filter ("all" shows everything).
 *   [data-card][data-cats]        — cards; data-cats is a "|"-separated list of category labels.
 *   [data-empty]                  — shown when nothing matches.
 *   [data-status]                 — polite live region for the result count.
 */
class IngredientFilter extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.addEventListener('input', () => this.#apply(), { signal });
    this.addEventListener('change', () => this.#apply(), { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #apply() {
    const query = (this.querySelector('[data-search]')?.value || '').trim().toLowerCase();
    const category = this.querySelector('input[data-cat]:checked')?.value || 'all';
    let shown = 0;

    for (const card of this.querySelectorAll('[data-card]')) {
      const cats = (card.dataset.cats || '').split('|');
      const text = (card.dataset.search || '').toLowerCase();
      const visible = (category === 'all' || cats.includes(category)) && (!query || text.includes(query));
      card.hidden = !visible;
      if (visible) shown += 1;
    }

    const empty = this.querySelector('[data-empty]');
    if (empty) empty.hidden = shown > 0;
    const status = this.querySelector('[data-status]');
    if (status) status.textContent = (status.dataset.template || '').replace('[count]', String(shown));
  }
}

if (!customElements.get('s-ingredient-filter')) customElements.define('s-ingredient-filter', IngredientFilter);
